export class TreeViewIconValueConverter {
	toView(value: string): string {
		if (value === undefined || value === null) {
			return null;
		}

		switch (value) {
			case "Device":
				return "router";
			case "DeviceType":
				return "settings_remote";
			case "DeviceTypes":
				return "devices";
			case "Location":
				return "location_city";
			case "Structure":
				return "store";
			case "Zone":
				return "grid_on";
			case "Root":
				return "developer_board";
			default:
				return null;
		}
	}
}